import { Link } from 'gatsby'
import React, { useState, useEffect, useCallback } from 'react'
import * as styles from './MobileNavigation.module.scss'
import useLazyLoadComponent from './../../../../hooks/useLazyLoadComponent'

import AboutLinkList from './../LinksLists/AboutLinkList'
import ServicesLinkList from './../LinksLists/ServicesLinkList'
import SocialIcon from '../../../UI/SocialMedia/SocialIcon/SocialIcon'

import { Icon } from '@iconify/react'

const LazyComponentSearch = ({ location, nameofClass }) => {
  const LazyLoadSearch = useLazyLoadComponent(location, nameofClass)
  return LazyLoadSearch
}

const MobileNavigation = ({ activeClass }) => {
  const [openSubLevel, setOpenSubLevel] = useState('')

  const sectionClickHandler = useCallback((e) => {
    e.preventDefault()
    const currentSection = e.target.id
    setOpenSubLevel(currentSection)
  }, [])

  const closeSectionHandler = useCallback(() => {
    setOpenSubLevel('')
  }, [])

  useEffect(() => {
    if (activeClass === '') {
      closeSectionHandler()
    }
  }, [activeClass, closeSectionHandler])

  return (
    <article id="mobileNav" className={`${styles.mobileNav} ${activeClass}`}>
      <div>
        <LazyComponentSearch
          location={'/Header/Navigation/Search/Search'}
          nameofClass={styles.mobileNav__search}
        />
        <section className={styles.mobileNav__linkList}>
          <ul>
            <li>
              <button
                id="aboutMobile"
                className={`${styles.mobileNav__mainCategory}`}
                onClick={sectionClickHandler}
              >
                <span>Meet Precise</span>
                <Icon
                  className={`${styles.dropdownArrow__icon}`}
                  icon="eva:arrow-ios-forward-fill"
                  inline={true}
                />
              </button>
              <div
                className={`${styles.mobileNav__subList} ${
                  openSubLevel === 'aboutMobile' ? styles.active : ''
                }`}
              >
                <h3>Meet Precise</h3>
                <AboutLinkList />
                <div className={styles.mobileNav__divider}></div>
                <button
                  className={styles.mobileNav__backBtn}
                  onClick={closeSectionHandler}
                >
                  <Icon
                    className={`${styles.dropdownArrow__icon}`}
                    icon="eva:arrow-ios-back-fill"
                    inline={true}
                  />
                  Back
                </button>
              </div>
            </li>
            <li>
              <button
                id="servicesMobile"
                className={`${styles.mobileNav__mainCategory}`}
                onClick={sectionClickHandler}
              >
                <span>Our Capabilities</span>
                <Icon
                  className={`${styles.dropdownArrow__icon}`}
                  icon="eva:arrow-ios-forward-fill"
                  inline={true}
                />
              </button>
              <div
                className={`${styles.mobileNav__subList} ${
                  openSubLevel === 'servicesMobile' ? styles.active : ''
                }`}
              >
                <h3>Our Capabilities</h3>
                <section className={styles.mobileNav__overflowContScroll}>
                  <ServicesLinkList />
                </section>
                <div className={styles.mobileNav__divider}></div>
                <button
                  className={styles.mobileNav__backBtn}
                  onClick={closeSectionHandler}
                >
                  <Icon
                    className={`${styles.dropdownArrow__icon}`}
                    icon="eva:arrow-ios-back-fill"
                    inline={true}
                  />
                  Back
                </button>
              </div>
            </li>
            <li>
              <Link
                to="/careers"
                className={`${styles.mobileNav__mainCategory}`}
              >
                <span>Careers</span>
                <Icon
                  className={`${styles.dropdownArrow__icon}`}
                  icon="eva:arrow-ios-forward-fill"
                  inline={true}
                />
              </Link>
            </li>
          </ul>
        </section>
        <section className={`${styles.mobileNav__bottomLinks}`}>
          <ul className={`${styles.mobileNav__bottomLinkList}`}>
            <li>
              <Link to="/contact-us/">
                <Icon
                  className={`${styles.nav_icon}`}
                  icon="codicon:mail"
                  inline={true}
                  height="24"
                  width="24"
                />
                <span>Contact Us</span>
                <Icon
                  className={`${styles.dropdownArrow__icon}`}
                  icon="eva:arrow-ios-forward-fill"
                  inline={true}
                />
              </Link>
            </li>
            <li>
              <a href="https://goprecise.sharepoint.us/" aria-label='Open new tab to MyPrecise'>
                <Icon
                  className={`${styles.nav_icon}`}
                  icon="carbon:data-vis-1"
                  inline={true}
                  height="24"
                  width="24"
                />
                <span>MyPrecise</span>
                <Icon
                  className={`${styles.dropdownArrow__icon}`}
                  icon="eva:arrow-ios-forward-fill"
                  inline={true}
                />
              </a>
            </li>
            <li>
              <a href="https://precisesystemsinc.sharepoint.com/" aria-label='Open new tab to MyPrecise'>
                <Icon
                  className={`${styles.nav_icon}`}
                  icon="codicon:gear"
                  inline={true}
                  height="24"
                  width="24"
                />
                <span>MyPrecise&mdash; <br/>Technical Solutions</span>
                <Icon
                  className={`${styles.dropdownArrow__icon}`}
                  icon="eva:arrow-ios-forward-fill"
                  inline={true}
                />
              </a>
            </li>
            <li>
              <Link to="/suppliers/">
                <Icon
                  className={`${styles.nav_icon}`}
                  icon="codicon:package"
                  inline={true}
                  height="24"
                  width="24"
                />
                <span>Suppliers</span>
                <Icon
                  className={`${styles.dropdownArrow__icon}`}
                  icon="eva:arrow-ios-forward-fill"
                  inline={true}
                />
              </Link>
            </li>
          </ul>
          <section className={styles.mobileNav__socialMedia}>
            <SocialIcon color="white" type="twitter" inline="true" />
            <SocialIcon color="white" type="youtube" inline="true" />
            <SocialIcon color="white" type="instagram" inline="true" />
            <div className={styles.flexBreak}></div>
            <SocialIcon color="white" type="linkedin" inline="true" />
            <SocialIcon color="white" type="facebook" inline="true" />
            <div className={styles.flexSpacer}></div>
          </section>
        </section>
      </div>
    </article>
  )
}

export default MobileNavigation
